import * as React from 'react';
import { connect } from 'react-redux';

import ShortlistButton from 'components/shortlist-button/ShortlistButton';
import ListButton from 'components/list-button/ListButton';
import NotesButton from 'modules/notes/components/button/NotesButton';

import './influencer-modal-actions.scss';

import type { InfluencerTile, ListContextMenu, LocationWindow, Organization } from 'types';
import type { Dispatch } from 'redux';

type OwnProps = {
  influencer: InfluencerTile,
  contextMenuProps?: ListContextMenu,
  isFreemium?: boolean,
  onDelete?: (a: InfluencerTile) => void
};

type StateProps = {
  location: LocationWindow,
  orgId: number,
  currentOrganization: Organization | undefined | null
};

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  dispatch: Dispatch // added by redux connect
} & OwnProps & StateProps;

type State = {
  autoOpenModal: {
    shortlist: boolean,
    collections: boolean,
    notes: boolean
  }
};

class InfluencerModalActions extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    const { location } = this.props;
    const queryString = location.querystring || '';

    this.state = {
      autoOpenModal: {
        shortlist: queryString.includes('openShortlist'),
        collections: queryString.includes('openCollections'),
        notes: queryString.includes('openNotes')
      }
    };
  }

  handleDelete = (): void => {
    const { influencer, onDelete } = this.props;

    if (onDelete) {
      onDelete(influencer);
    }
  };

  render(): React.ReactNode {
    const { orgId, influencer, contextMenuProps, currentOrganization, isFreemium } = this.props;
    const { autoOpenModal } = this.state;
    const listId = contextMenuProps?.listId || null;
    const brandProfileId = currentOrganization?.brandProfiles?.[0]?.id;

    return (
      <div
        className="influencer-modal-actions"
        data-qa="influencer-modal-actions"
      >
        <div className="influencer-modal-actions__item">
          <ShortlistButton
            orgId={orgId}
            brandProfileId={brandProfileId}
            influencer={influencer}
            autoOpenModal={autoOpenModal.shortlist}
            isFreemium={isFreemium}
          />
        </div>
        <div className="influencer-modal-actions__item">
          <ListButton
            orgId={orgId}
            influencer={influencer}
            autoOpenModal={autoOpenModal.collections}
            copyFromListId={listId}
            isFreemium={isFreemium}
            onDeleteFromCurrentList={this.handleDelete}
          />
        </div>
        <div className="influencer-modal-actions__item">
          <NotesButton
            influencer={influencer}
            autoOpenModal={autoOpenModal.notes}
            isFreemium={isFreemium}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ router, organizations }): StateProps => ({
  location: router.location,
  orgId: organizations.currentOrganizationId,
  currentOrganization: organizations.currentOrganization
});

export default connect(mapStateToProps)(InfluencerModalActions);
